import { useProfile } from "../../../context/contextProfile";
import { useWeb } from "../../../context/Dashboard/contextWeb";
import { useNetwork } from "../../../context/Dashboard/contextNetwork";
import { useAwsConfig } from "../../../context/Dashboard/aws/contextConfig";
import { useAzureConfig } from "../../../context/Dashboard/azure/contextConfig";
import { useGcpConfig } from "../../../context/Dashboard/gcp/contextConfig";

const ProfileComponent = () => {
  const {
    dashboard_id, companyName,
    email, setEmail,
    registeredRegIP,
    copyIp, setCopyIp,
    copyDId, setCopyDId
  } = useProfile();
  const { webResults } = useWeb();
  const { networkResults } = useNetwork();
  const { configAssets: awsConfigAssets } = useAwsConfig();
  const { configAssets: azureConfigAssets } = useAzureConfig();
  const { configAssets: gcpConfigAssets } = useGcpConfig();

  const pillStyle = 'rounded-pill me-1 px-2  py-1 bg-success text-white text-center fw-normal';
  const copyIpToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    setCopyIp(true);

    setTimeout(() => {
      setCopyIp(false);
    }, 2000);
  };

  const copyDIdToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    setCopyDId(true);

    setTimeout(() => {
      setCopyDId(false);
    }, 2000);
  };

  return (
    <>
      <div className="d-flex flex-column mb-3 col-7">
        <span>
          <div className="fw-bold mb-2">Company:</div>
          <input className="form-control" type="text"
            value={companyName} onChange={(e) => setEmail(e.target.value)} disabled />
        </span>
      </div>
      <div className="d-flex flex-column mb-3 col-7">
        <span>
          <div className="fw-bold mb-2">Email:</div>
          <input className="form-control" type="email"
            value={email} onChange={(e) => setEmail(e.target.value)} disabled />
        </span>
      </div>
      <div className="d-flex flex-column mb-3 col-7">
        <div className="fw-bold mb-2">Registered Services:</div>
        <div className="fw-bold mb-2 d-flex flex-row align-items-center">
          <div style={{ width: 70 }}>Web:</div> &nbsp;
          <span className={pillStyle}>
            {webResults?.length > 0 ? 'Regestered' : 'Not Regestered'}
          </span>
        </div>
        <div className="fw-bold mb-2 d-flex flex-row align-items-center">
          <div style={{ width: 70 }}>Network:</div> &nbsp;
          <span className={pillStyle}>
            {networkResults?.length > 0 ? 'Regestered' : 'Not Regestered'}
          </span>
        </div>
        <div className="fw-bold mb-2 d-flex flex-row align-items-center">
          <div style={{ width: 70 }}>Cloud:</div> &nbsp;
          <div className="d-flex flex-row">
            {awsConfigAssets?.length > 0 && <span className={pillStyle}>AWS</span>}
            {azureConfigAssets?.length > 0 && <span className={pillStyle}>Azure</span>}
            {gcpConfigAssets?.length > 0 && <span className={pillStyle}>GCP</span>}
            {!awsConfigAssets?.length > 0 &&
              !azureConfigAssets?.length > 0 &&
              !gcpConfigAssets?.length > 0 &&
              <span className={pillStyle}>Not Regestered</span>}
          </div>
        </div>
      </div>
      <div className="d-flex flex-column mb-3">
        <span>
          <div className="fw-bold mb-2">Registered IP: &nbsp;
            <span className="fw-normal">{registeredRegIP}</span>
            {registeredRegIP && (
              <span className="px-2" onClick={() => copyIpToClipboard(registeredRegIP)}>
                {copyIp ? <i className="bi bi-check" /> : <i className="bi bi-copy" />}
              </span>
            )}
          </div>
          <div className="fw-bold mb-2">Dashboard Id: &nbsp;
            <span className="fw-normal">{dashboard_id}</span>
            <span className="px-2" onClick={() => copyDIdToClipboard(dashboard_id)}>
              {copyDId ? <i className="bi bi-check" /> : <i className="bi bi-copy" />}
            </span>
          </div>
        </span>
      </div>
    </>
  )
}

export default ProfileComponent;
